import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {assetPath} from "@/shared/utils/asset-path";

import {Typography} from "../typography/typography";

import "./styles/rating.scss";

interface RatingProps {
    value?: number | null;
    /** Number of decimal places: false = 0, true = 1, 2 = precise (e.g., 4.73) */
    decimals?: boolean | number;
    size?: "small" | "medium" | "large";
    className?: string;
}

export function Rating({value, decimals = 1, size = "medium", className = ""}: RatingProps): JSX.Element | null {
    if (!value) {
        return null;
    }

    // Calculate decimal places: false = 0, true = 1, number = that number
    const decimalPlaces = decimals === false ? 0 : decimals === true ? 1 : decimals;
    const displayValue = value.toFixed(decimalPlaces);

    const sizeClasses = {
        small: "rating--small",
        medium: "rating--medium",
        large: "rating--large",
    };

    return (
        <div className={`rating ${sizeClasses[size]} ${className}`}>
            <SmartImage src={assetPath("/images/icons/black-star.svg")} alt="Rating" width={12} height={11} className="rating__icon" />
            <Typography as="span" size={14} weight={400} className="rating__value">
                {displayValue}
            </Typography>
        </div>
    );
}
